import { IconButton, Tooltip } from '@mui/material'
import VisibilityRounded from '@mui/icons-material/VisibilityRounded'
import VisibilityOffRounded from '@mui/icons-material/VisibilityOffRounded'
import { toggleAmountsHidden, useAmountsHidden } from '../privacy'

export default function PrivacyToggle() {
  const hideAmounts = useAmountsHidden()
  return (
    <Tooltip title={hideAmounts ? 'Afficher les montants' : 'Masquer les montants'}>
      <IconButton onClick={toggleAmountsHidden} sx={{ color: 'text.secondary' }}>
        {hideAmounts ? <VisibilityOffRounded /> : <VisibilityRounded />}
      </IconButton>
    </Tooltip>
  )
}
